"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _LazyKeyStore = require("../store/LazyKeyStore");

var _PropertiesAPI = require("./PropertiesAPI");

var _default = (0, _LazyKeyStore.registerLazyKeyService)({
  namespace: _ActionNamespaces.PROPERTIES,
  fetch: _PropertiesAPI.fetchPropertyGroupsBatch,
  idTransform: _identity.default
});

exports.default = _default;
module.exports = exports.default;